import type {Locale} from 'localization/types';
import type {RootState} from 'store/types';
import type {Thesaurus, ThesaurusId} from './types';
import {thesaurusApi} from './thesaurusApi';

/** Reads a single cached thesaurus from the RTK Query state. */
export const selectThesaurusData = (
  id: ThesaurusId,
  language: Locale,
): ((state: RootState) => Thesaurus | undefined) => {
  const selector = thesaurusApi.endpoints.getThesaurus.select({id, language});
  return state => selector(state).data;
};
